import { Book } from "@/types";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface BookCardProps {
  book: Book;
}

export function BookCard({ book }: BookCardProps) {
  return (
    <Link to={`/books/${book.slug}`} className="block">
      <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
        <div className="aspect-[3/4] relative bg-muted">
          {book.coverUrl ? (
            <img
              src={book.coverUrl}
              alt={book.title}
              className="object-cover w-full h-full"
              loading="lazy"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center text-muted-foreground">
              No cover
            </div>
          )}
        </div>
        <CardContent className="p-4">
          <h3 className="font-semibold mb-1">{book.title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {book.description}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
} 